<div class="d-flex">
  <div class="special-radio-btn-group flex-grow-1">
    <div class="container-fluid g-0">
      <div class="row mx-xs-0">
        <div class="col-md-12">

          <div class="btn-group btn-group-left d-md-inline-flex flex-wrap justify-content-center" role="group">
            @for (stageGroup of loanStageGroups; track stageGroup; let i = $index) {
              <input type="radio" id="tpoButton{{i}}" name="tpoBtnradio" class="btn-check" value="{{stageGroup}}"
                autocomplete="off" [(ngModel)]="selectedStageGroup" (ngModelChange)="onStageGroupChanged()">
                <label class="btn btn-outline-secondary" for="tpoButton{{i}}"> {{stageGroup}} </label>
              }
            </div>

            <div class="btn-group d-md-inline-flex flex-wrap justify-content-center mt-xs-2">
              <generic-filter #filter #loanStatusFilter class="ms-2 filter-buttons" [label]="'All Statuses'"
                [sortOptionsByDisplayName]="false" [filterHeader]="'Loan Status'" [filterOptions]="statusesToFilterWith"
                [disabled]="disableFilters" (filtersChanged)="onStatusFilterChanged($event)">
              </generic-filter>

              <generic-filter #filter #channelFilter class="ms-2 filter-buttons" [hidden]="hideChannelsSelector"
                [label]="'All Channels'" [filterHeader]="'Channels'" [filterOptions]="channelsToFilterWith"
                [disabled]="disableFilters" (filtersChanged)="onChannelsFilterChanged($event)">
              </generic-filter>

              <generic-filter #filter #loanPurposeFilter class="ms-2 filter-buttons" [label]="'All Loan Purposes'"
                [filterHeader]="'Loan Purposes'" [filterOptions]="loanPurposesToFilterWith" [disabled]="disableFilters"
                (filtersChanged)="onLoanPurposeFilterChanged($event)">
              </generic-filter>

              <!-- TPO-enabled role filter (primary role - e.g. Loan Officer) -->
              <generic-filter #filter [hidden]="hideLoSelector" class="ms-2" [icon]="'far fa-user'"
                [filterHeader]="'Loan Officers'" [showMoreFilterOptions]="showMoreRolesOptions[primaryRoleId]"
                [filterOptions]="officersToFilterWith" [disabled]="disableFilters" [searchable]="true"
                (filtersChanged)="onUserFilterChanged($event, primaryRoleId)">
              </generic-filter>

              <div class="btn-group">
                <button type="button" id="tpoButtonFilterByRoleId"
                  class="btn btn-outline-secondary tippy-btn btn-statuses ms-2 h-xs-fit-content" data-bs-container="body"
                  data-bs-toggle="popover" placement="bottom" [popover]="templateRoles" data-trigger="click"
                  [outsideClick]="true" [containerClass]="'templateRoles'" [disabled]="disableFilters"
                  (click)="onCreateFilterClicked()">
                  <span class="button-item-text">
                    <i class="fa-solid fa-filter"></i>
                  </span>
                </button>
                <ng-template #templateRoles>
                  <div class="first-five-filters" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                    <generic-filter #filter class="mx-1 filter-buttons-in-popup"
                      [label]="'All Statuses'" [sortOptionsByDisplayName]="false" [filterHeader]="'Loan Status'"
                      [filterOptions]="statusesToFilterWith" [disabled]="disableFilters"
                      (filtersChanged)="onStatusFilterChanged($event)">
                    </generic-filter>

                    <generic-filter #filter class="mx-1 filter-buttons-in-popup"
                      [hidden]="hideChannelsSelector" [label]="'All Channels'" [filterHeader]="'Channels'"
                      [filterOptions]="channelsToFilterWith" [disabled]="disableFilters"
                      (filtersChanged)="onChannelsFilterChanged($event)">
                    </generic-filter>

                    <generic-filter #filter class="mx-1 filter-buttons-in-popup"
                      [label]="'All Loan Purposes'" [filterHeader]="'Loan Purposes'"
                      [filterOptions]="loanPurposesToFilterWith" [disabled]="disableFilters"
                      (filtersChanged)="onLoanPurposeFilterChanged($event)">
                    </generic-filter>
                  </div>
                  <div class="role-filters-grid">
                    @for (role of otherRoles; track role) {
                      <generic-filter class="mx-1" [label]="role.roleName" [filterHeader]="role.roleName"
                        [filterOptions]="userFilterOptionsByRoleId.get(role.roleId)"
                        [showMoreFilterOptions]="showMoreRolesOptions[role.roleId]"
                        (filtersChanged)="onUserFilterChanged($event, role.roleId)">
                      </generic-filter>
                    }
                  </div>

                </ng-template>
                <div class="tpo-show-archived form-check form-switch form-switch-success d-inline-flex align-items-center ms-2 mb-0 h-xs-fit-content">
                  <input class="form-check-input form-check-input-md" type="checkbox" role="switch"
                    name="tpoShowArchived" id="tpoShowArchived" [disabled]="disableFilters"
                    [(ngModel)]="isShowAsArchiveActive" (ngModelChange)="onShowArchivedToggleChanged()">
                  <label class="form-check-label mb-0 ms-2 text-nowrap" for="tpoShowArchived">Show Archived</label>
                </div>
                <button type="button" class="btn btn-soft-danger btn-clear-all ms-2 h-xs-fit-content" title="Clear All"
                  (click)="clearAll()">
                  <i class="fas fa-times"></i>
                </button>
                @if (hasPendingFilterChanges) {
                  <button type="button" class="btn btn-primary ms-2 h-xs-fit-content" title="Apply Filters"
                    (click)="applyFilters()">
                    Apply Filters
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
